import { render } from "./XIconSolidShoppingCart.vue?vue&type=template&id=45253a75"
import script from "./XIconSolidShoppingCart.vue?vue&type=script&lang=js"
export * from "./XIconSolidShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidShoppingCart.vue"]])

export default __exports__